import { RouteObject } from 'react-router-dom';
import React from 'react';
import { CspPath } from '../../../CspPath';
import { PathUtil } from '../util/PathUtil';

const lazyLoadPages: () => Promise<typeof import('./CompliancePages')> = () =>
  import(/* webpackPrefetch: true */ './CompliancePages');

const PatientOverallComplianceContainer = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.PatientOverallComplianceContainer,
  })),
);

const PatientDetailedComplianceContainer = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.PatientDetailedComplianceContainer,
  })),
);

export const ComplianceRoutes: RouteObject[] = [
  {
    index: true,
    element: <PatientOverallComplianceContainer />,
  },
  {
    path: PathUtil.toRelativePath(CspPath.PATIENT_COMPLIANCE, CspPath.PATIENT_COMPLIANCE_DETAILS, true),
    element: <PatientDetailedComplianceContainer />,
  },
];
